/**
 * Type definitions for the frontend instrumentation framework.
 *
 * @see ../../knowledge-base/instrumentation-framework.md
 */
/** Ready-made `getContext` for a chain that needs no per-event context. */
export const emptyMiddlewareContext = () => ({});
export function asAutoInstrumented(payload) {
    return { autoInstrumented: true, ...payload };
}
/**
 * Default implementation for `ScopePayload<T>`. Identity factory: takes opts,
 * returns a getter that returns those opts. Type safety comes from the
 * annotation on the consuming declaration, not this implementation.
 */
export const SCOPE_PAYLOAD = (opts) => () => opts;
/**
 * Default implementation for {@link EventPayload}. Identity factory: renames the
 * literal `name` to `event` and passes the rest — `data`, plus `once` — straight
 * through, reusing the existing `TrackOptions` plumbing rather than reinventing
 * it. Type safety comes from the annotation on the consuming declaration, not here.
 */
export const EVENT_PAYLOAD = ({ name, ...rest }) => ({ event: name, ...rest });
/** Default implementation for {@link ImpressionPayload} (passes `key` through); see {@link EVENT_PAYLOAD}. */
export const IMPRESSION_PAYLOAD = ({ name, ...rest }) => ({
    event: name,
    ...rest,
});
/**
 * No-op transport config used when no instrumentation is wired up.
 *
 * `useInstrumentation()` always reads a non-null transport config from
 * context — when no provider is mounted (or when the host opted out of
 * instrumentation), this default keeps the hook on a single code path and
 * avoids null-branching at every call site. Calling `track()` simply hands
 * the assembled event to a no-op `send`.
 *
 * The sentinel `name` is unlikely to collide with any real app namespace,
 * but if a scope happens to share the name it still gets disambiguated by
 * the standard depth suffix. See `mergeScopeChain` for details.
 */
export const NOOP_INSTRUMENTATION_CONFIG = {
    send: () => { },
    name: '__root__',
    enabledState: { enabled: false, reason: 'dormant' },
};
//# sourceMappingURL=types.js.map